// extracted by mini-css-extract-plugin
module.exports = {"RequiredMaterials":"RequiredMaterials_RequiredMaterials__IGlT0"};